module.exports = __webpack_public_path__ + "static/img/HT-X9000F.a5b560c6.jpg";